<div mat-dialog-title>
  {{ data.title }}
  <div style="float: right; margin-top: -5px;">
    <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()">
      <img src="../../../../assets/close-white.png" style="width: 12px;">
    </button>
  </div>
</div>

<mat-dialog-content class="mat-typography">
  <div class="container my-2">
    <div class="row">
      <div class="col-11">
        <input class="form-control" type="text" [value]="url" #userinput>
      </div>
      <button class="col-1" mat-icon-button (click)="copy(userinput)">
        <img src="../../../../assets/other/export.png" style="width: 20px;">
      </button>
    </div>
    <p *ngIf="statusCopy" class="text-center text-success mt-2">{{statusCopy}}</p>
  </div>
</mat-dialog-content>
